export const generateAcumulator = (action, interval = 6000) => {
  let requests = 0
  let lastRun = new Date()
  let isScheduled = false

  const handleAction = () => {
    console.log(`[ACUMULATOR] Runing acumulator: ${requests} requests`)
    action()
    requests = 0
    lastRun = new Date()
    isScheduled = false
  }

  const verify = () => {
    let nextRunIn = interval - (new Date() - lastRun)
    if (nextRunIn < 0) {
      nextRunIn = 100
    }

    if (!isScheduled) {
      console.log(`[ACUMULATOR] Scheduled acumulator in: ${nextRunIn}`)
      isScheduled = true
      setTimeout(handleAction, nextRunIn)
    }
  }

  return () => {
    requests++
    verify()
  }
}
